export const CRM_NOTES_API_END_POINTS = {
  ADD_NOTE: "host/notes/create",
  GET_NOTES_LIST: "host/notes/list",
};
